import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/company/`;

const getCompanyBalance = async () => {
    return await axios.get(API_URL + 'balance');
};

export default {
    getCompanyBalance
}; 